import dynamic from "next/dynamic";
import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import FormHelperText from "@mui/material/FormHelperText";
import { Stack } from "@mui/material";

const Editor = dynamic(
  () => import("./editor").then((mod) => ({ default: mod.Editor })),
  { ssr: false },
);

interface Props<TFieldValues extends FieldValues> {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
  label?: string;
  required?: boolean;
  helperText?: string;
  disabled?: boolean;
  outputFormat?: "html" | "markdown";
}

export const RichTextInput = <TFieldValues extends FieldValues>({
  name,
  control,
  label,
  required,
  disabled,
  helperText,
  outputFormat = "html",
}: Props<TFieldValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <Stack sx={{ mb: "24px" }}>
          <Editor
            onChange={field.onChange}
            value={field.value}
            label={`${label}${required ? "*" : ""}`}
            error={!!fieldState.error}
            disabled={disabled}
            outputFormat={outputFormat}
          />

          <FormHelperText error={!!fieldState.error}>
            {fieldState.error?.message || helperText}
          </FormHelperText>
        </Stack>
      )}
    />
  );
};
